import { Api } from '@axiom/ui';
import type { User } from '@axiom/validation';

import { EnvUtil } from '../utils/env-util';

class UsersApiClass extends Api {
  constructor() {
    super({
      domain: EnvUtil.portalApiUrl,
    });
  }

  readCurrentUser() {
    return super.read<{ data: User }>({
      endpoint: '/user/me',
      method: 'GET',
    });
  }

  async updateUser(user: Partial<User>) {
    return super.write<{ data: User }>({
      endpoint: `/users/${user.id}`,
      method: 'PATCH',
      body: user,
    });
  }

  clearUser() {
    super.clear('/user/me');
  }
}

export const UsersApi = new UsersApiClass();
